import React from "react";
import { newEmailType } from "./SendEmailController";
import { Spinner } from "../../../../../ui/spinner";
import { X } from "lucide-react";

type AttachmentsListType = {
  selectedAttachments?: File[];
  message: newEmailType;
  updateEmail: (message: Partial<newEmailType>) => void;
};

const AttachmentsList = ({
  selectedAttachments,
  message,
  updateEmail
}: AttachmentsListType) => {
  const showSelectedAttachments: React.JSX.Element[] =
    selectedAttachments?.map((a) => {
      return (
        <div
          key={`${a.name}-${a.lastModified}`}
          className="attachmentsList flex items-center"
        >
          <span>{a.name}</span>
          <Spinner className="size-4" />
        </div>
      );
    }) ?? [];

  const attachments: React.JSX.Element[] =
    message.attachments.map((a) => {
      return (
        <div key={a.path} className="attachmentsList flex items-center">
          <span>{a.filename}</span>
          <button
            className="CloseButton bg-transparent -ml-[7px]"
            onClick={() => {
              const attachments = message.attachments.filter((aa) => aa !== a);
              updateEmail({
                attachments
              });
            }}
          >
            <X className="size-5" />
          </button>
        </div>
      );
    }) ?? [];

  const preDefinedSelectedAttachments: JSX.Element[] =
    message.preDefinedSelectedAttachments?.map((a) => {
      return (
        <div key={a._id} className="attachmentsList flex items-center">
          <span>{a.name}</span>
          <button
            className="CloseButton bg-transparent -ml-[7px]"
            onClick={() => {
              const preDefinedSelectedAttachments =
                message.preDefinedSelectedAttachments?.filter((aa) => aa !== a);
              updateEmail({
                preDefinedSelectedAttachments
              });
            }}
          >
            <X className="size-5" />
          </button>
        </div>
      );
    }) ?? [];

  return (
    <>
      {showSelectedAttachments}
      {attachments}
      {preDefinedSelectedAttachments}
    </>
  );
};

export default React.memo<AttachmentsListType>(AttachmentsList);
